import _styled from "styled-components";
import React from 'react';
import * as styles from "./NumericalLozenge.styles";
export var NumericalLozenge = function NumericalLozenge(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    className: "numericalLozenge",
    "data-greater-than-one-character": value.length > 1,
    $_css: styles.numericalLozenge
  }, value);
};
var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "NumericalLozenge___StyledSpan",
  componentId: "sc-35h4d2-0"
})(["", ""], function (p) {
  return p.$_css;
});